// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5044) return "static/chunks/c213cb58.addfab2135affe91.js";
	if (chunkId === 8619) return "static/chunks/8619.20b9d34c4a623170.js";
	if (chunkId === 2923) return "static/chunks/2923.b37101348c1048bd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"3060":"b3914ecf8f68c6b0","3478":"3b52171bb292231a","4424":"69f7c03212fae4d4","7508":"e21b458654354e43","8648":"7f7805e2a810f7dd"}[chunkId] + ".js";
};